module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.5509ca3f.png";